import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";
import { WorkOrderStatusEnum } from "modules/WorkOrderStatusEnum";

const StatusTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrder = { props };
  const isAwaitingAllocation = workOrder.props.status.localeCompare(WorkOrderStatusEnum.AwaitingAllocation, undefined, { sensitivity: "accent" }) === 0;
  return (
    <>
      <span data-testid="workOrderStatus" className={`${isAwaitingAllocation ? "work-order-awaiting-allocation" : ""}`}>
        {workOrder.props.status}
      </span>
    </>
  );
};
export default StatusTemplate;
